import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { OptionSelectorService } from "../canvas/services/option-selector.service";
import { LocaleExceptionsModel } from "../models/LocaleExceptionsModel";
import { NgxUiLoaderService } from "ngx-ui-loader"
import { LocaleExceptionsService } from "../services/localeExceptions.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "../engine/models/models";

@Component({
  selector: 'app-translator',
  templateUrl: './translator.component.html',
  styleUrls: ['./translator.component.css']
})
export class TranslatorComponent implements OnInit, AfterViewInit {
 availableLanguageCodes: any = [];
  filteredLanguageList: any[];
  filteredLanguage: any[];
  public localeExceptions: LocaleExceptionsModel = new LocaleExceptionsModel;
  public items: number = 0;
  isTranslatedList = false;
  isTranslated = false;
  displayedColumns: string[] = ['language', 'translation'];
  dataSource = [];
  selectedlanguageName: string;
  translation: string;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  myControl = new UntypedFormControl();
  languageControl = new UntypedFormControl();
  constructor(private service: OptionSelectorService,
    private loader: NgxUiLoaderService,
    private localeExceptionsService: LocaleExceptionsService,
    public dialogRef: MatDialogRef<TranslatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.loadLanguageCodes();
  }

  ngOnInit() {
   // this.loadLanguageCodes();
  }
  loadLanguageCodes() {
    this.localeExceptionsService.getLanguageCodes().subscribe(response => {
      this.availableLanguageCodes = response;
    });
  }

  searchLanguageList(value: string, record: any) {
    const filterValue = value.toLowerCase();
    if (value) {
      record.filteredLanguageList = this.availableLanguageCodes.filter(e => e.name && e.name.toLowerCase().includes(filterValue));
    }
    else {
      record.filteredLanguageList = this.availableLanguageCodes;
    }
    record.isActive = true;
    record.isbtnActive = false;
  }
  searchLanguage(value: string) {
    const filterValue = value.toLowerCase();
    if (value) {
      this.filteredLanguage = this.availableLanguageCodes.filter(e => e.name && e.name.toLowerCase().includes(filterValue));
    }
    else {
      this.filteredLanguage = this.availableLanguageCodes;
    }
  }

  ngAfterViewInit() {
    this.getAllTranslatedValues();
    setTimeout(() => {
      this.getAllTranslatedValues();
      const element: HTMLElement = document.getElementById('communityFilter') as HTMLElement;
      if (element !== null) {
        element.focus();
      }
    }, 1000);
  }



  languageChange(record, displayName) {
    displayName = displayName.replaceAll('/', ' ');
    this.loader.start();
    this.selectedlanguageName = this.availableLanguageCodes.find(x => x.languageCode == record.languageCode).name;
    this.filteredLanguage = [];
    this.localeExceptionsService.getTranslatedText(record.id, record.languageCode, displayName).subscribe(response => {
      this.localeExceptions.translation = response;
      this.loader.stop();
      this.translation = this.localeExceptions.translation;
      this.isTranslated = true;
      this.localeExceptions.isoCode = record.languageCode;
      this.localeExceptions.verbiage = displayName;
      this.localeExceptions.optionId = this.data.selectedOption;
      this.localeExceptions.id = 0;
      document.getElementById("inputTranslation").focus();
      this.saveTranslatedText('save', this.localeExceptions);
    });
  }
  languageChangeList(record, displayName, data) {
    displayName = displayName.replaceAll('/', ' ');
    this.filteredLanguageList = [];
    this.localeExceptionsService.getTranslatedText(record.id, record.languageCode, displayName).subscribe(response => {
     this.isTranslatedList = true;
      data.languageName = record.name;
      data.isActive = false;
      data.isbtnActive = true;
      data.translation = response;
      this.translation = data.translation;
      this.localeExceptions.isoCode = record.languageCode;
      this.localeExceptions.verbiage = displayName;
      this.localeExceptions.optionId = this.data.selectedOption;
      this.localeExceptions.id = 0;
      document.getElementById("inputTranslation").focus();
    });
  }
  getAllTranslatedValues() {
    this.localeExceptionsService.getAllTranslatedValues(this.data.selectedOption).subscribe(response => {
     this.dataSource = response.localeExceptions;
    });
  }
  saveTranslatedText(type: string, data: any) {
    if (type == "update") {
      this.localeExceptions.translation = data.translation;
      this.localeExceptions.isoCode = data.iSoCode;
      this.localeExceptions.id = data.id;
      this.localeExceptions.optionId = this.data.selectedOption;
     
      this.localeExceptionsService.saveTranslatedText(this.localeExceptions).subscribe(response => {
        this.localeExceptions = new LocaleExceptionsModel();
        this.isTranslated = false;
        this.isTranslatedList = false;
        this.selectedlanguageName = "";
        this.getAllTranslatedValues();
        this.localeExceptions.translation = "";
      }, error => console.error(error));
    }
    else {
      this.localeExceptions.optionId = this.localeExceptions.optionId;
      this.localeExceptionsService.saveTranslatedText(this.localeExceptions).subscribe(response => {
        this.localeExceptions = new LocaleExceptionsModel();
        this.isTranslated = false;
        this.isTranslatedList = false;
        this.selectedlanguageName = "";
        this.translation = "";
        this.getAllTranslatedValues();
      }, error => console.error(error));
    }
  }
  editbyId(item: any) {
    this.selectedlanguageName = item.languageName;
    this.localeExceptions = item;
    this.localeExceptions.translation = item.translation;
    this.localeExceptions.isoCode = item.isoCode;
    this.isTranslated = true;
    this.isTranslatedList = true;
    document.getElementById("inTranslation").focus();
  }
  clear() {
    this.filteredLanguage = [];
    this.filteredLanguageList = [];
  }
  deleteTranslate(id: number) {
    this.localeExceptionsService.deleteTranslate(id, "Test").subscribe(response => {
      const index = this.dataSource.findIndex(d => d.id === id);
      this.dataSource.splice(index, 1);
      event.preventDefault();
    });
  }
 
  closeDialog(): void {
    this.service.loadOption(null);
    this.dialogRef.close();
  }
}
